import React, { PropsWithChildren } from "react"

type MyProps = {
    className?: string
}

const ModalFooter = ({ children, className }: PropsWithChildren<MyProps>) => {
    return (
        <div className={`tw-px-6 tw-py-3 tw-flex-grow ${className ?? ""}`}>
            {children}
        </div>
    )
}
export default ModalFooter